var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { observable, action, computed } from "mobx";
import { BlockCondition } from "sb-resp-block-lib";
import { InternalMessageBusChannels } from "sb-internal-msg-bus";
import { DateRangePeriod } from "../types";
import { config } from "../blocks/BettingHistory/config";
import { dateDifferenceCalculator, isValidISODate } from "../helpers";
export class Retriever {
    constructor(props) {
        this.isActive = false;
        this.request = props.request;
        this.dateRange = props.dateRange;
        this.cache = props.cache;
        this.betsReportingApiConnection = props.betsReportingApiConnection;
        this.condition = BlockCondition.EMPTY;
        this.messageBus = props.messageBus;
        this.messageBus.on(InternalMessageBusChannels.legacy.userInfo.onLogin, this.subscribeForLogin, this);
        this.messageBus.on(InternalMessageBusChannels.legacy.timeZone.update, this.onTimeZoneChange, this);
        this.config = props.config;
        this.statistics = {
            totalProfit: 0,
            totalStake: 0
        };
    }
    activate() {
        this.isActive = true;
        this.request.to = new Date();
        this.request.from = dateDifferenceCalculator(this.request.to, DateRangePeriod.Last24Hours);
        return this.setData();
    }
    deactivate() {
        this.isActive = false;
        this.statistics.totalProfit = 0;
        this.statistics.totalStake = 0;
    }
    updateDateRange(dateRange) {
        this.request.to = new Date();
        this.request.from = dateDifferenceCalculator(this.request.to, dateRange);
        this.dateRange = dateRange;
        return this.setData();
    }
    loadMore() {
        if (this.nextToDate && isValidISODate(this.nextToDate)) {
            this.request.to = new Date(this.nextToDate);
            this.loadMoreData();
        }
    }
    updateStatistics(stats) {
        this.statistics.totalProfit = stats.totalProfit;
        this.statistics.totalStake = stats.totalStake;
    }
    get getCurrentDateRangeAsKey() {
        return JSON.stringify({ from: this.request.from, to: this.request.to });
    }
    loadMoreData() {
        this.betsReportingApiConnection.getSettledBets({
            locale: this.request.locale,
            fromDate: this.request.from.toISOString(),
            toDate: this.request.to.toISOString(),
            top: this.request.top
        }).then(response => {
            this.nextToDate = response.nextToDate;
            this.cache.add(response);
        }).catch(err => {
            this.condition = BlockCondition.ERROR;
            throw err;
        });
    }
    setData() {
        this.condition = BlockCondition.LOADING;
        return this.betsReportingApiConnection.getSettledBets({
            locale: this.request.locale,
            fromDate: this.request.from.toISOString(),
            toDate: this.request.to.toISOString(),
            top: this.request.top
        }).then(response => {
            if (!this.isActive) {
                return;
            }
            this.condition = BlockCondition.LOADED;
            this.nextToDate = response.nextToDate;
            this.updateStatistics(response.statistics);
            this.cache.add(response);
            if (response.bets.length === this.request.top) {
                this.loadMore();
            }
            this.checkResponseCount();
        }).catch(err => {
            this.condition = BlockCondition.ERROR;
        });
    }
    checkResponseCount() {
        if (this.cache.data.length === 0) {
            this.condition = BlockCondition.EMPTY;
        }
    }
    onTimeZoneChange(timeZoneMsg) {
        this.config.currentTimeZone = timeZoneMsg.data[0].currentSelectedTimeZone;
    }
    subscribeForLogin(message) {
        this.config.currencyCode = message.data[0].ISOCurrencyCode;
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], Retriever.prototype, "request", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], Retriever.prototype, "cache", void 0);
__decorate([
    observable,
    __metadata("design:type", Number)
], Retriever.prototype, "dateRange", void 0);
__decorate([
    observable,
    __metadata("design:type", Number)
], Retriever.prototype, "condition", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], Retriever.prototype, "config", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], Retriever.prototype, "statistics", void 0);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], Retriever.prototype, "updateDateRange", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Retriever.prototype, "loadMore", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Retriever.prototype, "updateStatistics", null);
__decorate([
    computed,
    __metadata("design:type", String),
    __metadata("design:paramtypes", [])
], Retriever.prototype, "getCurrentDateRangeAsKey", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Retriever.prototype, "onTimeZoneChange", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Retriever.prototype, "subscribeForLogin", null);
//# sourceMappingURL=Retriever.js.map